import { Button, Flex, Input } from "@chakra-ui/react";
import React from "react";

const OrderSearchHeading = () => {
  return (
    <Flex justifyContent={"space-between"}>
      <Input disabled type="search" w={"40%"} placeholder="Search invoices" />
    </Flex>
  );
};

export default OrderSearchHeading;
